import AddAssignmentForm from "../../../components/Admin/Assignments/AddAssignmentForm";
import Navbar from "../../../components/Navbar";

export default function AddAssignment() {
  return (
    <>
      <Navbar />
      <section className="py-6 bg-primary">
        <div className="mx-auto max-w-full px-5 lg:px-20">
          <AddAssignmentForm />
        </div>
      </section>
    </>
  );
}
